import { useEffect, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background_L.webp'
import backgroundM from './images/Background_M.webp'
import backgroundS from './images/Background_S.webp'
import handMobileL from './images/HandMobile_L.webp'
import handMobileM from './images/HandMobile_M.webp'
import handMobileS from './images/HandMobile_S.webp'
import womanShadowL from './images/WomanShadow_L.webp'
import womanShadowM from './images/WomanShadow_M.webp'
import womanShadowS from './images/WomanShadow_S.webp'
import {
  AnimationContainer,
  Background,
  HandMobile,
  WomanShadow,
} from './styled'
import { useAppContext } from 'context/app-context'

export const Animation = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
  }

  useEffect(() => {
    if (loadedImages === 3) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  return (
    <IntroContainer>
      <AnimationContainer>
        <picture>
          <source
            srcSet={backgroundS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={backgroundM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Background src={backgroundL} alt="" onLoad={onLoadImages} />
        </picture>
        <picture>
          <source
            srcSet={handMobileS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={handMobileM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <HandMobile
            src={handMobileL}
            alt=""
            onLoad={onLoadImages}
            $isPageVisible={isPageVisible}
          />
        </picture>

        <picture>
          <source
            srcSet={womanShadowS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={womanShadowM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <WomanShadow
            alt=""
            src={womanShadowL}
            onLoad={onLoadImages}
            $isPageVisible={isPageVisible}
          />
        </picture>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title>Солидарность и поддержка в сети</Title>
        <Subtitle>
          Как девушка из Казахстана ушла от абьюзера благодаря женскому форуму и
          почему решила вернуться
        </Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
